import React, { useState } from "react";
import { Card } from "react-bootstrap";
import defaultProfilePic from "../assets/defaultProfilePic.png";

const ProfileImage = ({ imageId, setImageError }) => {
  const [altImage, setAltImage] = useState(false);

  const handleImageError = () => {
    if (setImageError) {
      setImageError(true);
    }
    setAltImage(true);
  };

  const cacheBuster = new Date().getTime();

  return (
    <Card
      style={{
        justifyContent: "center",
        alignItems: "center",

        border: "none",
        borderRadius: "10px",
      }}
    >
      {altImage ? (
        <img
          src={defaultProfilePic}
          width={350}
          height={300}
          alt="Profile"
          style={{ borderRadius: "10%" }}
        />
      ) : (
        <img
          src={`https://zpottergym.s3.ap-south-1.amazonaws.com/${imageId}?${cacheBuster}`}
          width={350}
          height={300}
          onError={handleImageError} // Handle image loading error
          alt="Profile"
          style={{ borderRadius: "10%" }}
        />
      )}
    </Card>
  );
};

export default ProfileImage;
